// services/batchProcessing.service.js
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL_API;

export const batchProcessingService = {
async processBatch(batchData) {
  try {
    const formData = new FormData();
    
    batchData.items.forEach((item, index) => {
      const prefix = `items.${index}`;
      
      formData.append(`${prefix}.axis_file`, item.axisFile);
      
      if (item.stakeFile) {
        formData.append(`${prefix}.stake_file`, item.stakeFile);
      } else {
        formData.append(`${prefix}.stake_file`, '');
      }
      
      formData.append(`${prefix}.img_file`, item.imgFile);
      formData.append(`${prefix}.processing_method`, item.processingMethod);
      formData.append(`${prefix}.start_point_label`, item.startPointLabel || '0+000');
      formData.append(`${prefix}.task_name`, item.taskName || '');
      formData.append(`${prefix}.start_name_column`, item.startNameColumn || 'Name');
      formData.append(`${prefix}.crs`, item.crs || 'EPSG:31982');
      formData.append(`${prefix}.eixo_direction`, item.eixoDirection || 'AUTOMATICO');
    });

    console.log('FormData entries:');
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await axios.post(`${baseUrl}api/process-batch/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Token ${this.getAuthToken()}`
      },
      timeout: 60000
    });
    return response.data;
  } catch (error) {
    console.error('Erro no processamento em lote:', error);
    console.error('Resposta de erro:', error.response?.data);
    throw new Error(error.response?.data?.error || 'Erro no processamento em lote');
  }
},

async getBatchStatus(batchId) {
  try {
    const response = await axios.get(`${baseUrl}api/batch-status/${batchId}/`, {
      headers: {
        'Authorization': `Token ${this.getAuthToken()}`
      },
      timeout: 10000
    });
    
    
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar status do lote:', error);
    throw new Error(error.response?.data?.message || 'Erro ao verificar status do lote');
  }
},

  async downloadBatchResults(batchId) {
    try {
      const response = await axios.get(`${baseUrl}api/batch-download/${batchId}/`, {
        responseType: 'blob',
        headers: {
          'Authorization': `Token ${this.getAuthToken()}`
        },
        timeout: 120000
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `batch_results_${batchId}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return true;
    } catch (error) {
      console.error('Erro no download do lote:', error);
      throw new Error(error.response?.data?.message || 'Erro ao baixar resultados do lote');
    }
  },

  getAuthToken() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      return user.token;
    }
    return null;
  }
};